import { composeIO } from 'react-compose-io'
import { modalAddContaIO } from './ModalAddConta.IO'
import ModalAddContaView from './ModalAddConta.View'

export const ModalAddConta = composeIO(ModalAddContaView, modalAddContaIO)
